import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  paramName: PropTypes.string.isRequired,
  value: PropTypes.bool,
  disabled: PropTypes.bool
};

var Switch = function (_Component) {
  _inherits(Switch, _Component);

  function Switch(props) {
    _classCallCheck(this, Switch);

    var _this = _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this, props));

    _this.onChange = function (e) {
      _this.setState({
        value: e.target.checked
      });

      _this.props.onChange({
        paramName: _this.props.paramName,
        value: e.target.checked
      });
    };

    _this.state = {
      value: props.value || ''
    };
    return _this;
  }

  _createClass(Switch, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value && this.state.value !== nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }

    /*
     ** We use handmade shouldComponentUpdate instead of PureComponent in order to ignore the onChange function
     ** it allows us to create a new function on every render in the parent : onChange={() => { doSomething() }}
     ** without rerendering the component everytime the parent is rendered (PureComponent have this side effect )
     */

  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var ignores = ['onChange'];
      for (var prop in propTypes) {
        if (ignores.indexOf(prop) !== -1) {
          continue;
        }
        if (prop === 'value' && (this.state.value !== nextState.value || this.state.value !== nextProps.value)) {
          return true;
        }

        if (this.props[prop] !== nextProps[prop]) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          paramName = _props.paramName,
          onChange = _props.onChange,
          value = _props.value,
          size = _props.size,
          props = _objectWithoutProperties(_props, ['className', 'paramName', 'onChange', 'value', 'size']);

      return React.createElement(
        'label',
        { className: 'switch' + (className ? ' ' + className : '') + (size ? ' ' + size : '') },
        React.createElement('input', { type: 'checkbox', onChange: this.onChange, checked: this.state.value }),
        React.createElement('span', { className: 'slider round' })
      );
    }
  }]);

  return Switch;
}(Component);

Switch.propTypes = propTypes;

export default Switch;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/Switch/index.js
// module id = 422
// module chunks = 0